module.exports = __webpack_public_path__ + "img/21.bdceec1c.jpg";